import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SessionProvider, useSession } from "@/context/SessionContext";
import { ProgressBar } from "@/components/ProgressBar";
import Landing from "@/pages/Landing";
import ProjectDetails from "@/pages/ProjectDetails";
import StyleFeed from "@/pages/StyleFeed";
import Palette from "@/pages/Palette";
import Conversation from "@/pages/Conversation";
import FurnitureFeed from "@/pages/FurnitureFeed";
import Board from "@/pages/Board";
import Admin from "@/pages/Admin";

const FLOW = ["/project", "/styles", "/palette", "/about", "/furniture", "/board"];

function RequireSession({ children }) {
  const { session, loading } = useSession();
  if (loading) return <div className="min-h-screen" />;
  if (!session) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  const { pathname } = useLocation();
  useEffect(() => { document.title = "interiorsmoodboard — find your interior taste"; }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  const inFlow = FLOW.includes(pathname);
  return (
    <div className="App grain">
      {inFlow && <ProgressBar />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/project" element={<RequireSession><ProjectDetails /></RequireSession>} />
        <Route path="/styles" element={<RequireSession><StyleFeed /></RequireSession>} />
        <Route path="/palette" element={<RequireSession><Palette /></RequireSession>} />
        <Route path="/about" element={<RequireSession><Conversation /></RequireSession>} />
        <Route path="/furniture" element={<RequireSession><FurnitureFeed /></RequireSession>} />
        <Route path="/board" element={<RequireSession><Board /></RequireSession>} />
        <Route path="/b/:id" element={<Board readOnly />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" toastOptions={{ className: "font-body" }} />
    </div>
  );
}

export default function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </SessionProvider>
  );
}
